import array from './array';
import confirmAlert from './confirm-alert';
import date from './date';
import object from './object';
import filter from './filter';

export default [array, confirmAlert, date, filter, object];
